// @flow
import {createSelector} from 'reselect';
import {pathOr, includes, __} from 'ramda';

import type {SelectorType} from 'constants/flow/flowTypes';
import {PAGES_WITH_STICKY_HEADER} from 'constants/pages';

/**
 * Takes page name
 * @type {SelectorType<string>}
 */
export const getPage: SelectorType<string> = pathOr('', ['pageApp', 'page']);

/**
 * Determines should current page have sticky header or not
 * @type {SelectorType<boolean>}
 */
export const isPageWithStickyHeader: SelectorType<boolean> = createSelector(
    getPage,
    includes(__, PAGES_WITH_STICKY_HEADER),
);
